import { Box, Typography, useMediaQuery } from '@mui/material';
import { SubmissionType } from '@protos/learning_management/lms.db_pb';
import { HomeworkTask } from '@protos/learning_management/lms.hw.common.apis_pb';
import { remainingTimeInHoursAndMins } from '../../../commonUtils/homework';
import { pxToRem, pxTovW } from '../../../commonUtils/resizeUtils';
import { IStyles } from '../../../commonUtils/styleUtils';
import { formatDateAsDayMonth } from '../../../commonUtils/utilFunctions';
import { IconWrapper } from '../../elements/IconWrapper/Index';
import ImageWrapper from '../../elements/ImageWrapper';
import { ScoreProgressBar } from '../ScoreProgressBar';
import { AssessmentTask } from '@protos/learning_management/lms.assessment.common.apis_pb';
import { getMediaBasePath, theme } from '@geneo2-web/shared-ui';
const styles: IStyles = {
  root: {
    height: { xs: pxToRem(120), md: pxTovW(270), lg: pxTovW(132) },
    width: { xs: '100%', md: pxTovW(590), lg: pxTovW(341) },
    borderRadius: { xs: pxToRem(10) },
    backgroundColor: '#FFFFFF',
    border: '1px solid #E0DFDE',
    padding: { xs: pxToRem(12), md: pxToRem(6), lg: pxTovW(12) },
    display: 'flex',
    alignItems: 'center',
    gap: { xs: pxToRem(10), lg: pxTovW(14) },
    boxSizing: 'border-box',
    boxShadow: `0px 0px ${pxToRem(11)} #E7E7E7D9`,
    position: 'relative',
  },
  imageBox: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    height: { xs: pxToRem(103), md: pxTovW(230), lg: pxTovW(107) },
    // width: { xs: pxToRem(110), md: pxTovW(107) },
    width: { xs: pxToRem(103), md: pxTovW(230), lg: pxTovW(107) },
    minWidth: { xs: pxToRem(103), md: pxTovW(170), lg: pxTovW(107) },

    // boxSizing: 'content-box',
    boxSizing: 'border-box',
    borderRadius: { xs: pxToRem(10) },
    backgroundColor: '#E0DFDE',
    position: 'relative',
  },
  image: {
    width: '100%',
    objectFit: 'cover',
    borderRadius: { xs: pxToRem(10), md: pxTovW(10) },
  },

  progressContainer: {
    // border: '1px solid green',
    boxSizing: 'border-box',
    position: 'absolute',
    bgcolor: '#FFFFFFE6',
    width: '100%',
    height: { xs: pxToRem(37), md: pxTovW(37) },
    bottom: 0,
    opacity: '90%',
    borderRadius: {
      xs: `0 0 ${pxToRem(10)} ${pxToRem(10)}`,
      md: `0 0 ${pxTovW(10)} ${pxTovW(10)}`,
    },
    p: { xs: pxToRem(5), md: pxTovW(5) },

    display: 'flex',
    gap: { xs: pxToRem(2), md: pxTovW(2) },
    flexDirection: 'column',
  },

  iconBox: {
    display: 'flex',
    // flexDirection: 'column',
    gap: { xs: pxToRem(2), md: pxTovW(2) },
    // justifyContent: 'space-around',
    // backgroundColor: 'red',
    // wordWrap: 'break-word',

    alignItems: 'center',
    width: 'max-content',
  },
  ribbon: {
    position: 'absolute',
    top: { xs: pxToRem(4), md: pxToRem(2), lg: pxTovW(5) },
    right: { xs: pxToRem(-5), md: pxToRem(-2), lg: pxTovW(-5) },
    paddingX: { xs: pxToRem(5), md: pxToRem(2), lg: pxTovW(10) },
    paddingTop: { xs: pxToRem(5), md: pxToRem(10), lg: pxTovW(10) },
    paddingBottom: { xs: pxToRem(2), md: 0, lg: pxTovW(4) },
    width: { xs: pxToRem(66), lg: pxTovW(65) },
    height: { xs: pxToRem(17), lg: pxTovW(15) },
    textAlign: 'center',
    background: '#F8C807',
    clipPath: 'polygon(93% 28%, 93% 0, 100% 27%, 100% 100%, 0 99%, 0 28%)',
    borderTopLeftRadius: '50px',
    borderBottomLeftRadius: '30px',
  },
};
interface IProps {
  clickHandler?: () => void;
  hwAssigned?: AssessmentTask;
  hwDraft?: AssessmentTask;
  hwType?: 'Draft' | 'Assigned' | 'Ended';
  subjectName: string;
  submissionType?: SubmissionType;
  maxMarks?: number;
}

export const ManageHomeworkCard = (props: IProps) => {
  const {
    clickHandler,
    hwAssigned,
    hwDraft,
    hwType,
    subjectName,
    submissionType,
    maxMarks,
  } = props;
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const isIpad = useMediaQuery(theme.breakpoints.down('lg'));
  const isIpadOnly = !isMobile && isIpad;
  return (
    <Box sx={styles.root} onClick={clickHandler}>
      <Box sx={styles.imageBox}>
        <ImageWrapper
          name="chapter1"
          type="png"
          parentFolder="tempAssets"
          styles={{
            ...styles.image,
            // height: hwType !== 'Draft' ? '60%' : '100%',
            height: '100%',
          }}
          path={getMediaBasePath(
            hwAssigned?.assessmentPosterImgUrl ||
              hwDraft?.assessmentPosterImgUrl,
            'processedMediaBucket'
          )}
        />
        {/* {hwType !== 'Draft' && (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              width: '90%',
              margin: { xs: pxToRem(5), md: pxTovW(4) },
              // backgroundColor: 'red',
              boxSizing: 'content-box',
              gap: pxToRem(2),
            }}
          > */}

        {/* {hwType !== 'Draft' && (
          <ScoreProgressBar
            variant="small"
            score={hwAssigned?.classScore || 0}
          />
        )}
        {hwType !== 'Draft' && (
          <Typography variant="smallestText" sx={{ marginLeft: pxToRem(5) }}>
            Class Score
          </Typography>
        )} */}

        {submissionType === SubmissionType.SUBMISSION_ONLINE ||
          submissionType === SubmissionType.SUBMISSION_OFFLINE ||
          (hwType !== 'Draft' && (
            <Box sx={styles.progressContainer}>
              <ScoreProgressBar
                variant={isIpadOnly ? 'md' : 'small'}
                score={Math.round(hwAssigned?.classScore || 0)}
              />

              <Typography
                variant="smallestText"
                sx={{ marginLeft: pxToRem(5) }}
              >
                Class Score
              </Typography>
            </Box>
          ))}
      </Box>

      <Box
        sx={{
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          flexGrow: 1,
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
            }}
          >
            <Typography variant="smallText" color="primary.main">
              {hwAssigned?.class || hwDraft?.class}
              {hwAssigned?.section || hwDraft?.section} -{' '}
              {hwAssigned?.subject || hwDraft?.subject}
            </Typography>

            {submissionType === SubmissionType.SUBMISSION_ONLINE ||
            submissionType === SubmissionType.SUBMISSION_OFFLINE ? (
              <Typography variant="subText" fontWeight={600} sx={styles.ribbon}>
                Custom HW
              </Typography>
            ) : (
              <Typography></Typography>
            )}
          </Box>
          <Typography
            variant="cardText"
            fontWeight="bold"
            sx={{
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              WebkitLineClamp: 1,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              maxHeight: pxToRem(20),
              paddingTop: { xs: pxToRem(3), md: pxTovW(5) },
              maxWidth: { xs: pxToRem(190), md: pxTovW(300), lg: pxTovW(190) },
            }}
          >
            {hwAssigned?.moduleName || hwDraft?.moduleName}
          </Typography>

          <Typography
            variant="smallText"
            fontWeight="regular"
            sx={{
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              WebkitLineClamp: 1,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
              maxWidth: { xs: pxToRem(180), md: pxTovW(190) },
            }}
          >
            {hwAssigned?.assessmentTitle || hwDraft?.assessmentTitle}
          </Typography>
        </Box>
        <Box
          sx={{
            display: 'flex',
            boxSizing: 'border-box',
            justifyContent: 'space-between',
          }}
        >
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              // gap: { xs: pxToRem(12), md: pxTovW(12) },
              //   border: '1px solid red',
              justifyContent: 'space-around',
              alignItems: 'center',
              boxSizing: 'border-box',
            }}
          >
            {hwType === 'Draft' ? (
              <>
                {' '}
                <Box sx={styles.iconBox}>
                  <IconWrapper
                    name="clock"
                    size={isIpadOnly ? 'md' : 'small'}
                    parentFolder="icons"
                    type="png"
                  />

                  <Typography variant="smallText">
                    {`${
                      hwAssigned?.assessmentContentInfo?.timeDurationInMin ||
                      hwDraft?.assessmentContentInfo?.timeDurationInMin
                    } mins`}
                  </Typography>
                </Box>
                <Box sx={styles.iconBox}>
                  <IconWrapper
                    name="questions"
                    size={isIpadOnly ? 'md' : 'small'}
                    parentFolder="icons"
                    type="png"
                  />
                  <Typography variant="smallText">
                    {hwAssigned?.assessmentContentInfo?.numberOfQuestions ||
                      hwDraft?.assessmentContentInfo?.numberOfQuestions}
                  </Typography>
                </Box>
                <Box sx={styles.iconBox}>
                  <IconWrapper
                    name="level"
                    size={isIpadOnly ? 'md' : 'small'}
                    parentFolder="icons"
                    type="png"
                  />
                  <Typography variant="smallText">
                    {difficultyLevelToString(
                      hwAssigned?.difficultyLevel ||
                        hwDraft?.difficultyLevel ||
                        0
                    )}
                  </Typography>
                </Box>
              </>
            ) : submissionType === SubmissionType.SUBMISSION_ONLINE ||
              submissionType === SubmissionType.SUBMISSION_OFFLINE ? (
              <Box
                sx={{
                  display: 'flex',
                  marginRight: 'auto',
                  gap: { xs: pxToRem(4), md: pxTovW(6) },
                  marginBottom: { xs: pxToRem(4), md: pxTovW(10) },
                  alignItems: 'center',
                }}
              >
                <IconWrapper
                  name="tnc"
                  size={isIpadOnly ? 'md' : 'small'}
                  parentFolder="icons"
                  type="png"
                />
                {maxMarks === undefined ? (
                  <Typography variant="smallText" fontWeight={900}>
                    {submissionType === SubmissionType.SUBMISSION_ONLINE
                      ? 'Digital without Marks'
                      : 'Physical without Marks'}
                  </Typography>
                ) : (
                  <Typography variant="smallText" fontWeight={900}>
                    {submissionType === SubmissionType.SUBMISSION_ONLINE
                      ? 'Digital with Marks'
                      : 'Physical with Marks'}
                  </Typography>
                )}
              </Box>
            ) : (
              <Box
                sx={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'space-between',
                  boxSizing: 'border-box',
                  // backgroundColor: 'red',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    // backgroundColor: 'red',
                  }}
                >
                  <Box sx={styles.iconBox}>
                    <IconWrapper
                      name="profile"
                      size={isIpadOnly ? 'md' : 'small'}
                      parentFolder="icons"
                      type="png"
                    />
                    <Typography variant="smallText">{`${
                      hwAssigned?.studentsSubmissionCount || 0
                    }/${hwAssigned?.assignedStudentsCount || 0}`}</Typography>
                  </Box>
                  <Typography variant="smallText" fontWeight="regular">
                    Submissions
                  </Typography>
                </Box>
                {hwType === 'Assigned' ? (
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      marginLeft: 'auto',
                      padding: 0,
                      margin: 0,
                    }}
                  >
                    <Box sx={styles.iconBox}>
                      <IconWrapper
                        name="clock"
                        size={isIpadOnly ? 'md' : 'small'}
                        parentFolder="icons"
                        type="png"
                      />
                      <Typography
                        variant="smallText"
                        sx={{
                          maxWidth: { md: pxTovW(85) },
                          textOverflow: 'ellipsis',
                          whiteSpace: 'nowrap',
                          WebkitLineClamp: 1,
                          WebkitBoxOrient: 'vertical',
                          overflow: 'hidden',
                        }}
                      >
                        {remainingTimeInHoursAndMins(
                          hwAssigned?.assessmentTargetDate ||
                            hwDraft?.assessmentTargetDate
                        )}
                      </Typography>
                    </Box>
                    <Typography variant="smallText" fontWeight="regular">
                      Remaining
                    </Typography>
                  </Box>
                ) : (
                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Box sx={styles.iconBox}>
                      <IconWrapper
                        name="calender"
                        size={isIpadOnly ? 'md' : 'small'}
                        parentFolder="icons"
                        type="png"
                      />
                      <Typography variant="smallText">
                        {formatDateAsDayMonth(
                          hwAssigned?.assessmentTargetDate ||
                            hwDraft?.assessmentTargetDate
                        )}
                      </Typography>
                    </Box>
                    <Typography variant="smallText" fontWeight="regular">
                      Deadline
                    </Typography>
                  </Box>
                )}
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
// function formatSecondsToDateString(seconds) {
//   const date = new Date(seconds * 1000);
//   const day = date.getDate();
//   const month = date.toLocaleString('default', { month: 'short' });

//   return `${day} ${month}`;
// }
function formatTimestampToDateString(
  seconds: bigint | undefined
): string | undefined {
  if (seconds === undefined) {
    return undefined;
  }
  const date = new Date(Number(seconds) * 1000);
  const day = date.getDate();
  const month = date.toLocaleString('default', { month: 'short' });
  return `${day} ${month}`;
}

const difficultyLevelToString = (value: number) => {
  switch (value) {
    case 0:
      return 'Undefined';
      break;
    case 1:
      return 'High';
      break;
    case 2:
      return 'Medium';
      break;
    case 3:
      return 'Low';
      break;

    default:
      break;
  }
};
